<template>
  <el-dialog
    title="編輯群組成員"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字">
              <el-input
                v-model="queryForm.qstr"
                placeholder="編號、班名、名稱、序號、備註"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button
            type="primary"
            @click="handleBatchJoin"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次加入</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchQuit"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次移除</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 部門：{{ deptName }} / 群組：{{
          groupName
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            v-loading="isLoading"
            ref="dataTable"
            @selection-change="handleSelectionChange"
            :data="members"
            @sort-change="sortChange"
            :default-sort="{ prop: 'member.no', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="人員編號"
              prop="member.no"
              sortable="custom"
              width="150"
            >
            </el-table-column>
           <el-table-column
              label="班級名稱"
              prop="member.className"
              sortable="custom"
              width="150"
            >
            </el-table-column>

            <el-table-column
              label="月光機序號"
              prop="member.moonlight2SerialNumber"
              sortable="custom"
              width="200"
            >
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="member.name"
              sortable="custom"
              width="150"
            >
            </el-table-column>

 

            <el-table-column label="備註" prop="member.memo" width="180">
            </el-table-column>

            <el-table-column label="加入群組">
              <template #default="scope">
                <el-switch
                  :value="isGroupDeptMember(scope.row)"
                  active-text="是"
                  inactive-text="否"
                  :disabled="isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  @change="
                    isMember => setMember(isMember, scope.row, scope.$index)
                  "
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "@/api/";
import { mapGetters } from "vuex";
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: Number,
      default: null,
    },
    groupName: {
      type: String,
      default: null,
    },
    deptId: {
      type: Number,
      default: null,
    },
    deptName: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      members: "deptMember/deptMembers",
      total: "deptMember/total",
      offset: "deptMember/offset",
      sort: "deptMember/sort",
      order: "deptMember/order",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      isLoading: false,
      disabledSwitchIdx: [],
      selectedRow: [],
      pageSize: 50,
      formLabelWidth: "100px",
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
      activeQueryForm: {
        qstr: "",
      },
    };
  },
  created() {
    this.$store.commit("deptMember/CLEAR");
    if (this.innerVisible) {
      //NOTE: always start from the first page
      this.query(this.pageSize, 0, this.sort, this.order);
    }
  },
  methods: {
    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row, null, false, false));
        }
      });

      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push(runningItem[idx].name);
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          this.query(
            this.pageSize,
            this.offset,
            this.sort,
            this.order,
            this.activeQueryForm
          ).then(() => {
            failedItem.forEach(failedName => {
              const failedOne = this.members.find(
                item => item.name === failedName
              );
              failedOne &&
                this.$refs.dataTable.toggleRowSelection(failedOne, true);
            });
            //NOTE: we intentionally set loading to false ONLY when query succeeds
            this.isLoading = false;
          });
        });
    },

    handleBatchJoin() {
      const isSkipped = row => (this.isGroupDeptMember(row) ? true : false);
      this.batchHandler(isSkipped, this.joinGroup.bind(this), "批次加入成功");
    },
    handleBatchQuit() {
      const isSkipped = row => (!this.isGroupDeptMember(row) ? true : false);
      this.batchHandler(isSkipped, this.quitGroup.bind(this), "批次移除成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    setMember(isMember, mbr, index) {
      const isChecked = this.selectedRow.find(row => row.name === mbr.name);
      let p;
      this.disabledSwitchIdx.push(index);
      if (isMember) {
        p = this.joinGroup(mbr, index);
      } else {
        p = this.quitGroup(mbr, index);
      }
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.members[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    joinGroup(mbr, index, updateStore = true, showMsg = true) {
      const params = {};
      params.groupId = this.groupId;
      params.memberId = mbr.member.id;
      return API.groupDeptMember.add(params).then(res => {
        if (updateStore) {
          const newMbr = { ...mbr };
          const groupDeptMembers = [{}];
          groupDeptMembers[0].id = res.data.id;
          newMbr.groupDeptMembers = groupDeptMembers;

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("deptMember/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "加入成功!",
          });
      });
    },

    quitGroup(mbr, index, updateStore = true, showMsg = true) {
      return API.groupDeptMember.remove(mbr.groupDeptMembers[0].id).then(() => {
        if (updateStore) {
          const newMbr = { ...mbr };
          newMbr.groupDeptMembers = [];

          const payload = {};
          payload.newMbr = newMbr;
          payload.index = index;
          this.$store.commit("deptMember/CHANGE_MEMBER", payload);
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "移除成功!",
          });
      });
    },

    isGroupDeptMember(mbr) {
      return mbr.groupDeptMembers.length > 0 ? true : false;
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      return this.$store
        .dispatch("deptMember/list", {
          dept: this.deptId,
          group: this.groupId,
          max: max,
          offset: offset,
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.disabledSwitchIdx = [];
        });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("deptMember/SET_SORT", "member.no");
        this.$store.commit("deptMember/SET_ORDER", "ascending");
      } else {
        this.$store.commit("deptMember/SET_SORT", args.prop);
        this.$store.commit("deptMember/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    handleDlgClose() {
      //this.$store.dispatch('member/list', null);
    },
  },
};
</script>

<style></style>
